module.exports = __webpack_public_path__ + "static/media/delete-icon.64e75ca2.svg";